'use strict';

import MathUtil from '../math_util/math_util';
import PowerFormatter from '../power-formatter/power-formatter.logic';
import moment from 'moment';

class GroupReportUtil {
  /*@ngInject*/
  constructor(MathUtil, PowerFormatter) {
    this.MathUtil = MathUtil;
    this.PowerFormatter = PowerFormatter;
  }

  /*
    in:[
          {
              measured_at: '2017-01-01T00:00:00+09:00',
              powers: [
                  { sa_config_id: 1, pms_service_code: 'tds0000001', value: 100 },
                  { sa_config_id: 2, pms_service_code: 'tds0000002', value: 100 },
                  { sa_config_id: 3, pms_service_code: 'tds0000003', value: 100 }
              ]
          },
          {
              measured_at: '2017-01-01T00:00:30+09:00',
              ...
          },
          ...
      ]
    out:[
          { id: 1, name: 'tds0000001', data: [{ x: null, y: null }, { x: null, y: null }] }, // 先頭が空きの場合 null が入る
          { id: 2, name: 'tds0000002', data: [{ x: null, y: null }, { x: null, y: null }] },
          { id: 3, name: 'tds0000003', data: [{ x: null, y: null }, { x: null, y: null }] }
      ]
  */
  createSeriesList(groupActivePowers, shiftRange = 0) {
    let seriesList = [];
    groupActivePowers.forEach(groupActivePower => {
      groupActivePower.powers.forEach(power => {
        let seriesIndex = this.indexOfObjectArray(seriesList, power.sa_config_id);

        if (seriesIndex === -1) {
          let series = {
            id: power.sa_config_id,
            name: power.pms_service_code,
            location: power.location,
            memo: power.memo,
            data: []
          };

          for (let i = 0; i < shiftRange; i++) {
            series.data.push({date: null, y: null});
          }
          seriesList.push(series);
        }
      });
    });

    return seriesList;
  }

  /*
    in:[
          {
              measured_at: '2017-01-01T00:00:00+09:00',
              powers: [
                  { sa_config_id: 1, pms_service_code: 'tds0000001', value: 100 },
                  { sa_config_id: 2, pms_service_code: 'tds0000002', value: 100 },
                  { sa_config_id: 3, pms_service_code: 'tds0000003', value: 100 }
              ]
          },
          {
              measured_at: '2017-01-01T00:00:30+09:00',
              ...
          },
          ...
      ],
      [
          { id: 1, name: 'tds0000001', data: [null, null] },
          { id: 2, name: 'tds0000002', data: [null, null] },
          { id: 3, name: 'tds0000003', data: [null, null] }
      ]
    out:[
          { id: 1, name: 'tds0000001', data: [null, null, 100, 200] }, // data の中身は not 差分
          { id: 2, name: 'tds0000002', data: [null, null, 100, 200] },
          { id: 3, name: 'tds0000003', data: [null, null, 100, 200] }
      ],
      [{ name: '合計値', data: [null, null, 300 600] }]
  */
  createStackSeries(seriesList, groupActivePowers, shiftRange = 0) {
    let sumSeries = {name: '合計値', data: []};
    for (let i = 0; i < shiftRange; i++) {
      sumSeries.data.push({date: null, y: null});
    }

    groupActivePowers.forEach(groupActivePower => {
      let sum = 0;
      let dateString = groupActivePower.measured_at || groupActivePower.date;
      let date = moment(dateString).toDate();

      seriesList.forEach((series, seriesIndex) => {
        let powerIndex = this.indexOfObjectArray(groupActivePower.powers, series.id);
        if (powerIndex === -1) {
          series.data.push({
            date: date,
            y: null
          });
        } else {
          series.data.push({
            date: date,
            y: groupActivePower.powers[powerIndex].value
          });
          sum = this.MathUtil.add(sum, groupActivePower.powers[powerIndex].value);
        }
      });

      sumSeries.data.push({
        date: date,
        y: sum
      });
    });

    return [seriesList, [sumSeries]];
  }

  createSumSeries(seriesList) {
    let sumData = [];
    let sumSeries = {name: '合計値', data: []};

    if (seriesList.length === 0) {
      return sumSeries;
    }

    for (let i = 0; i < seriesList[0].data.length; i++) {
      let sum = 0;
      seriesList.forEach(series => {
        if (series.data[i] && series.data[i].y) {
          sum = this.MathUtil.add(sum, series.data[i].y)
        }
      });

      sumSeries.data.push({
        date: seriesList[0].data[i].date,
        y: sum
      });
    }

    return sumSeries;
  }

  createDiffArray(seriesList) {
    seriesList.forEach(series => {
      let data = [];
      series.data.reduce((pre, current) => {
        if ((pre && current) && (current.y !== 0 && pre.y !== 0)) {
          data.push({
            date: current.date,
            y: this.PowerFormatter.calcDailyPowerDiff(current.y, pre.y)
          });
        } else {
          data.push({
            date: current.date,
            y: null
          });
        }

        return current;
      }, {y: 0, date: null});

      data.shift();
      series.data = data;
    });

    return seriesList;
  }

  indexOfObjectArray(array, id) {
    let index = -1;
    array.some((element, i) => {
      if ((element.id || element.sa_config_id) === id) {
        index = i;
        return;
      }
    });

    return index;
  }
}

export default angular.module('leptonApp.GroupReportUtil', [MathUtil, PowerFormatter])
  .service('GroupReportUtil', ['MathUtil', 'PowerFormatter', GroupReportUtil])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/logic/group_report/group_report_util.service.js